// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3ukC9","label":"SetPasswdForm_label__2mpnb"};